import React from 'react';
import { Link } from 'react-router-dom';

import { MCButton, TextField } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import {
  withRouter,
  scssVariables as variables,
  lang,
  formatDuration,
  permissions,
  isAdminPage
} from 'src/helpers';

import model from './model';
import mainModel from 'src/model';
import errorDescriptions from 'src/constants/errors';
import LANG_CONST from 'src/helpers/lang/const';

const apiStateId = 'forgotPw';

let intervalId = 'ForgotPassword';

const urlPrefix = isAdminPage() ? 'ADMIN_' : '';

class ForgotPw extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    this.init();
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
  }

  init = () => {
    model.resetApiState(apiStateId);
    this.timer(() => model.state.resetExpired > Date.now(), intervalId);

    if (!this.props.router.location.state?.no_reset) model.setState(model.defaultState());
  };

  handleSubmit = (event) => {
    event.preventDefault();

    mainModel.checkConfirmCookiePolicy().then((accept) => {
      return (
        accept &&
        model.forgotPw((err, res) => {
          if (res?.ok) {
            this.navigate(permissions.PAGES[urlPrefix + 'RESET_PASSWORD_PAGE'].path);
          } else if (res?.expired) {
            model.setState({ resetExpired: res.expired });
            this.timer(() => model.state.resetExpired > Date.now(), intervalId);
          }
        })
      );
    });
  };

  renderEmail = () => {
    let createState = model.getApiState(apiStateId);
    let { invalid } = createState;
    let { handleChange, handleBlur } = model;

    return (
      <>
        <TextField
          template={6}
          autoFocus={true}
          name={'email'}
          value={model.input('email')}
          onChange={(n, v) => {
            model.resetApiState(apiStateId);
            model.setStateSilent({ resetExpired: 0 });
            handleChange(n, v);
          }}
          onBlur={handleBlur}
          label={LANG_CONST.email_address}
          invalid={invalid}
        />
        <div
          style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
          onClick={() => {
            model.resetApiState(apiStateId);
            model.setState({ resetByPhone: true, resetExpired: 0 });
          }}
        >
          {lang.t(LANG_CONST.text.reset_by_phone)}
        </div>
      </>
    );
  };

  renderPhone = () => {
    let createState = model.getApiState(apiStateId);
    let { invalid } = createState;
    let { handleChange, handleBlur } = model;

    return (
      <>
        <TextField
          template={6}
          autoFocus={true}
          defaultCountryName={model.state.countryAddress}
          name={'phoneNumber'}
          type='phone'
          value={model.input('phoneNumber').toString()}
          onChange={(n, v) => {
            model.resetApiState(apiStateId);
            model.setStateSilent({ resetExpired: 0 });
            handleChange(n, v);
          }}
          onBlur={handleBlur}
          label={LANG_CONST.phone_number}
          invalid={invalid}
        />
        <div
          style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
          onClick={() => {
            model.resetApiState(apiStateId);
            model.setState({ resetByPhone: false, resetExpired: 0 });
          }}
        >
          {lang.t(LANG_CONST.text.reset_by_email)}
        </div>
      </>
    );
  };

  render() {
    let createState = model.getApiState(apiStateId);
    let { loading, errorMessage, error } = createState;

    const expired = model.state.resetExpired;
    const expiredIn = (expired - Date.now()) / 1000;
    const blocked = expiredIn > 0;

    if (error === 'BLOCKED') errorMessage = '';

    if (error === 'USER_NOT_FOUND')
      errorMessage = errorDescriptions(
        !model.state.resetByPhone ? 'EMAIL_NOT_REGISTERED' : 'PHONE_NUMBER_NOT_REGISTERED'
      );

    return (
      <div className={'mc-page-auth-box'}>
        <div className={'mc-box-header'}>
          <h4 className='mc-box-title'>{lang.t(LANG_CONST.titles.forgot_pw)}</h4>
          <div className='mc-box-title-note'>{lang.t(LANG_CONST.text.forgot_pw_no_worries)}</div>
        </div>
        {!!errorMessage && <p className='mc-error'>{errorMessage}</p>}
        <form className='mc-form' onSubmit={this.handleSubmit}>
          {!model.state.resetByPhone && this.renderEmail()}
          {model.state.resetByPhone && this.renderPhone()}

          {blocked && (
            <div className={'mc-label-418'}>
              {lang.t(LANG_CONST.notice.forgot_code_sent, {
                type: model.state.resetByPhone ? 'phone' : 'email',
                blockedInMin: formatDuration(expiredIn)
              })}
            </div>
          )}

          <MCButton
            key={this.state.renderId}
            large
            radius
            type='submit'
            disabled={blocked || loading}
            primary
            dark={!blocked}
            light={blocked}
            loading={loading}
            label={
              blocked
                ? lang.t(LANG_CONST.buttons.reset_pw_in, { duration: formatDuration(expiredIn) })
                : LANG_CONST.buttons.reset_pw
            }
          />
          <div className='mc-label-420'>
            <span className=''>{lang.t(LANG_CONST.back_to_txt)} </span>
            <Link
              to={permissions.PAGES[urlPrefix + 'LOGIN_PAGE'].path}
              onClick={() => model.resetApiState(apiStateId)}
              style={{ color: variables['colors-mc-primary'], cursor: 'pointer' }}
            >
              {lang.t(LANG_CONST.log_in)}
            </Link>
          </div>
        </form>
      </div>
    );
  }
}

export default withRouter(ForgotPw);
